import React from 'react';
import img from './JustReDi_speira.png'
import './justrediLoader.css'

export function JustrediLoader(props) {
    return (
        <div className={`filtered-image font-semibold text-3xl fixed w-full h-full flex items-center justify-center ${props && !props.opacity ? 'bg-white' : 'bg-white/80'} z-50 top-0 left-0`}>
            <div className="rotation-container">
                <div className="rotating-wrapper">
                    <img src={img} alt={'alt'} className="rotating-image" />
                    <div className="highlight-mask" />
                </div>
            </div>
        </div>
    );
}

export default JustrediLoader;
